export default "__VITE_ASSET__CWHrjBvf__"